import { render, staticRenderFns } from "./TablePatientXDiagnose.vue?vue&type=template&id=ed8139d6&"
import script from "./TablePatientXDiagnose.vue?vue&type=script&lang=js&"
export * from "./TablePatientXDiagnose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports